import React from 'react';
import SearchBox from './SearchBox';
import './TopBar.css';

export default function TopBar({ onNavigate, industries, industryId, onIndustryChange, theme, onToggleTheme, navOpen, onMenuToggle }) {
  return (
    <header className="topbar">
      <div className="topbar-left">
        <button
          className={`topbar-hamburger${navOpen ? ' topbar-hamburger--open' : ''}`}
          onClick={onMenuToggle}
          aria-label={navOpen ? 'Close navigation' : 'Open navigation'}
        >
          <span /><span /><span />
        </button>
        <div className="logo">
          <span className="logo-mark">🧾</span>
          <span className="logo-name">Billing</span>
        </div>
      </div>

      <div className="topbar-center">
        {industries && (
          <>
            <span className="industry-label">Industry</span>
            <div className="industry-picker" role="group" aria-label="Select industry">
              {industries.map((ind) => (
                <button
                  key={ind.id}
                  className={`industry-option${industryId === ind.id ? ' industry-option--active' : ''}`}
                  onClick={() => onIndustryChange(ind.id)}
                >
                  {ind.label}
                </button>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="topbar-right">
        <SearchBox onNavigate={onNavigate} />
        <button
          className="topbar-theme-toggle"
          onClick={onToggleTheme}
          aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
        >
          {theme === 'dark' ? '☀︎' : '☽'}
        </button>
      </div>
    </header>
  );
}
